import axios from 'axios';
import Toast from 'light-toast';
import React, { Component } from 'react';
import {
  FaCheck, FaTrash
} from 'react-icons/fa';

import { fetchAuthSession } from 'aws-amplify/auth';

import cookies from '../utils/cookies.util';
import base_url from '../utils/request.util';

class RMList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rmDataWithClient: {},
      client_id: '',
      name: '',
      added_by: '',
      is_verified: false,
      suggestions: [],
      rms: []
    };
    this.fetchSuggestions = this.fetchSuggestions.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.addClient = this.addClient.bind(this);
    this.removeClient = this.removeClient.bind(this);
    this.selectedUser = this.selectedUser.bind(this);
    this.getRmDataWithClient = this.getRmDataWithClient.bind(this);
  }

  async getRmDataWithClient(rmData) {

    await fetchAuthSession().then(() => {
      const config = {};
      config.headers = {
        'Authorization': cookies.get('Authorization'),
        'User-Specified': cookies.get('User-Specified'),
        'Type-Specified': cookies.get('Type-Specified')
      };

      axios
        .get(`${base_url}/relationship-management/${rmData.email}`, config)
        .then((res) => {
          Toast.success('Success', 1000, () => { });

          this.setState({
            rmDataWithClient: res.data.item,
          });
        })
        .catch((error) => {
          console.log(error);
          Toast.fail('Error Performing Action', 3000);
        });
    });
  }

  async addClient() {
    Toast.loading('In Progress', () => { });

    if (this.state.rmDataWithClient.email === '' || this.state.rmDataWithClient.email == null) {
      Toast.fail('Please select RM', 3000);
      return;
    }

    if (this.state.client_id === '') {
      Toast.fail('Please select RM', 3000);
      return;
    }
    await fetchAuthSession().then(() => {
      const config = {};
      config.headers = {
        'Authorization': cookies.get('Authorization'),
        'User-Specified': cookies.get('User-Specified'),
        'Type-Specified': cookies.get('Type-Specified')
      };

      const data = {
        rm_id: this.state.rmDataWithClient.email,
        client_id: this.state.client_id,
        added_by: this.state.added_by
      };

      axios
        .patch(`${base_url}/relationship-management/${this.state.rmDataWithClient.email}`, data, config)
        .then((res) => {
          this.setState({
            client_id: ''
          }, () => {
            this.getRmDataWithClient(this.state.rmDataWithClient);
          });
        })
        .catch((error) => {
          console.log(error);
          Toast.fail('Error Performing Action', 3000);
        });
    });
  }

  async removeClient(clientId) {
    Toast.loading('In Progress', () => { });
    await fetchAuthSession().then(() => {
      const config = {};
      config.headers = {
        'Authorization': cookies.get('Authorization'),
        'User-Specified': cookies.get('User-Specified'),
        'Type-Specified': cookies.get('Type-Specified')
      };
      config.data = {
        client_id: clientId
      };
      axios
        .delete(`${base_url}/relationship-management/${this.state.rmDataWithClient.email}`, config)
        .then((res) => {
          this.setState({
            client_id: ''
          }, () => {
            this.getRmDataWithClient(this.state.rmDataWithClient);
          });
          Toast.success('Success', 1000, () => { });
        })
        .catch((error) => {
          console.log(error);
          Toast.fail('Error Performing Action', 3000);
        });
    });
  }


  async fetchSuggestions(event) {
    if (event.target.value === '') return;

    await fetchAuthSession().then(() => {
      const config = {};
      config.headers = {
        'Authorization': cookies.get('Authorization'),
        'User-Specified': cookies.get('User-Specified'),
        'Type-Specified': cookies.get('Type-Specified')
      };
      config.params = {
        q: event.target.value
      };
      axios
        .get(`${base_url}/user/suggest`, config)
        .then((res) => {
          this.setState({
            suggestions: res.data.items
          });
        })
        .catch((error) => {
          console.log(error);
          Toast.fail('Error Performing Action', 3000);
        });
    });
  }

  handleChange(event) {
    this.setState({ [event.target.id]: event.target.value });
    if (event.target.id === 'client_id') this.fetchSuggestions(event);
  }

  async componentDidMount() {

    this.setState({
      added_by: cookies.get('User-Specified')
    });

    await fetchAuthSession().then((user) => {
      const config = {};
      config.params = { user_type: 'RelationshipManager' };
      config.headers = {
        'Authorization': cookies.get('Authorization'),
        'User-Specified': user.tokens.accessToken.payload.username,
        'Type-Specified': user.tokens.accessToken.payload['cognito:groups']
      };
      axios
        .get(`${base_url}/user`, config)
        .then((res) => {
          this.setState({
            rms: res.data.items
          });
          Toast.hide();
        })
        .catch((error) => {
          console.log(error);
          Toast.fail('Error Performing Action', 3000);
        });
    });
  }

  selectedUser(event) {
    this.setState({
      client_id: event.target.id,
      suggestions: []
    });
  }

  render() {

    return (
      <div id="rmDataWithClient">
        <div className="row">
          <div className="col-3">
            {this.state.rms.map((rm, index) => {
              return (
                <button
                  type="button"
                  className="btn  btn-primary  btn-block"
                  onClick={() => this.getRmDataWithClient(rm)}
                >
                  {rm.name}
                </button>
              );
            })}
          </div>
          <div className="col-9">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Client</th>
                  <th scope="col">Added By</th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                {(this.state.rmDataWithClient.clients || []).map((client, index) => (
                  <tr key={index}>
                    <th scope="row">{index + 1}</th>
                    <td>{client.client_id}</td>
                    <td>{client.added_by}</td>
                    <td>
                      <a
                        className="btn btn-danger"
                        id={index}
                        key={index}
                        onClick={() => this.removeClient(client.client_id)}
                      >
                        <FaTrash />
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
              <tbody>
                <tr>
                  <th scope="row">{(this.state.rmDataWithClient.clients || []).length + 1}</th>
                  <td>
                    <input
                      type="text"
                      value={this.state.client_id}
                      onChange={this.handleChange}
                      className="form-control"
                      required
                      id="client_id"
                    />

                    <div className="dropdown">
                      <ul className="list-group">
                        {this.state.suggestions.map((value, index) => {
                          return (
                            <li
                              className="list-group-item list-group-flush"
                              onClick={this.selectedUser}
                              id={value.user_id}
                              key={index}
                            >
                              {value.user_id}
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  </td>
                  <td>
                    <input
                      type="text"
                      value={this.state.added_by}
                      className="form-control"
                      disabled
                      id="added_by"
                    />
                  </td>
                  <td>

                    <a
                      className="btn btn-success"
                      onClick={() => this.addClient()}
                    >
                      <FaCheck />
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}

export default RMList;
